<div class="dialogContainer">
  <div class="dialogHeader">
    <img
      class="closeButton"
      src="/images/closeIconWithoutBox.png"
      (click)="closeDialog()"
      />
    </div>
    <div class="dialogContent">
      <div>
        <app-dialog-input-title
          title="Navn"
          [required]="true"
        ></app-dialog-input-title>
        <input type="text" class="Textbox" [(ngModel)]="user.name" />
      </div>
      <div>
        <div>
          <app-dialog-input-title title="Initialer"></app-dialog-input-title>
          <input type="text" class="Textbox" [(ngModel)]="user.initials" />
        </div>
        <div>
          <app-dialog-input-title
            title="Medarbejdernummer"
          ></app-dialog-input-title>
          <input type="text" class="Textbox" [(ngModel)]="user.employeeNumber" />
        </div>
        <app-dialog-input-title
          title="Email"
          [required]="true"
        ></app-dialog-input-title>
        <input type="text" class="Textbox" [(ngModel)]="user.email" />
      </div>
      <div>
        <app-dialog-input-title
          title="Intern titel"
          [required]="true"
        ></app-dialog-input-title>
        <select
          [(ngModel)]="selectedInternalTitleId"
          class="dropdown"
          [compareWith]="this.sharedFunctionsService.compareIds"
          >
          @for (internalTitle of internalTitles; track internalTitle) {
            <option
              [value]="internalTitle.id"
              >
              {{ internalTitle.name }}
            </option>
          }
        </select>
      </div>
      <div>
        <app-dialog-input-title
          title="Afdeling"
          [required]="true"
        ></app-dialog-input-title>
        <select
          [(ngModel)]="selectedDepartmentId"
          class="dropdown"
          [compareWith]="this.sharedFunctionsService.compareIds"
          >
          @for (department of departments; track department) {
            <option [value]="department.id">
              {{ department.displayName }}
            </option>
          }
        </select>
      </div>
      <div>
        <app-dialog-input-title
          title="Nærmeste leder"
          [required]="false"
        ></app-dialog-input-title>

        <select [(ngModel)]="user.nearestManagerId" class="dropdown">
          <option value="0" ></option>
          @for (nearestManager of nearestManagers; track nearestManager) {
            <option
              [value]="nearestManager.id">
              {{ nearestManager.name }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="dialogFooter">
      <app-save-button
      [disabled]="
        !user.name.trim() ||
        !user.email.trim() ||
        !user.departmentId ||
        !user.internalTitleId
      "
        [clickEvent]="saveChanges.bind(this)"
        >
      </app-save-button>
      <app-delete-button [clickEvent]="deleteUser.bind(this)">
      </app-delete-button>
    </div>
  </div>
